import { FREE_DROP_NOTIFICATION_DURATION } from '../constants/free-drop';
import { NotificationType } from '../enums/notification-type';
import { FreeDropNotificationType } from '../enums/free-drop';
import { BoostedJackpotStore } from './boostedJackpotStore';
import { UserActivityStore } from './user-activity-store';
import { TranslationsStore } from './translations-store';
import { NotificationStore } from './notification-store';
import { PostMessageStore } from './post-message-store';
import { SideBarMenuStore } from './sideBar-menu-store';
import { SideMenuIcons } from '../enums/side-menu-icons';
import { SlotHistoryStore } from './slot-history-store';
import { MaintenanceStore } from './maintenance-store';
import { TournamentStore } from './tournament-store';
import { FreeSpinStore } from './free-spin-store';
import { FreeDropStore } from './free-drop-store';
import { CashbackStore } from './cashback-store';
import { JackpotStore } from './jackpot-store';
import { LoaderStore } from './loader-store';
import { PromoStore } from './promo-store';
import { ModalStore } from './modal-store';
import { LobbyStore } from './lobby-store';
import { AuthStore } from './auth-store';
import { GameStore } from './game-store';
import { HubStore } from './hub-store';

export class RootStore {

  public hubStore: HubStore;
  public authStore: AuthStore;
  public gameStore: GameStore;
  public modalStore: ModalStore;
  public promoStore: PromoStore;
  public lobbyStore: LobbyStore;
  public loaderStore: LoaderStore;
  public jackpotStore: JackpotStore;
  public cashbackStore: CashbackStore;
  public freeDropStore: FreeDropStore;
  public freeSpinStore: FreeSpinStore;
  public tournamentStore: TournamentStore;
  public slotHistoryStore: SlotHistoryStore;
  public maintenanceStore: MaintenanceStore;
  public sidebarMenuStore: SideBarMenuStore;
  public postMessageStore: PostMessageStore;
  public translationsStore: TranslationsStore;
  public userActivityStore: UserActivityStore;
  public boostedJackpotStore: BoostedJackpotStore;
  public rewardsNotificationStore: NotificationStore;
  public sidebarNotificationStore: NotificationStore<SideMenuIcons>;
  public toastNotificationStore: NotificationStore<NotificationType>;
  public freeDropNotificationStore: NotificationStore<FreeDropNotificationType>;

  constructor() {
    this.hubStore = new HubStore(this);
    this.authStore = new AuthStore(this);
    this.gameStore = new GameStore(this);
    this.modalStore = new ModalStore(this);
    this.promoStore = new PromoStore(this);
    this.lobbyStore = new LobbyStore(this);
    this.loaderStore = new LoaderStore(this);
    this.jackpotStore = new JackpotStore(this);
    this.cashbackStore = new CashbackStore(this);
    this.freeDropStore = new FreeDropStore(this);
    this.freeSpinStore = new FreeSpinStore(this);
    this.tournamentStore = new TournamentStore(this);
    this.sidebarMenuStore = new SideBarMenuStore(this);
    this.slotHistoryStore = new SlotHistoryStore(this);
    this.maintenanceStore = new MaintenanceStore(this);
    this.postMessageStore = new PostMessageStore(this);
    this.translationsStore = new TranslationsStore(this);
    this.userActivityStore = new UserActivityStore(this);
    this.boostedJackpotStore = new BoostedJackpotStore(this);
    this.rewardsNotificationStore = new NotificationStore(this);
    this.sidebarNotificationStore = new NotificationStore<SideMenuIcons>(this, { gap: 2 * 60_000, startPaused: true });
    this.toastNotificationStore = new NotificationStore<NotificationType>(this);
    // shown by the slot line free drop widget, which resumes the queue once it is visible
    this.freeDropNotificationStore = new NotificationStore<FreeDropNotificationType>(this, { duration: FREE_DROP_NOTIFICATION_DURATION, startPaused: true });
  }
}

export const rootStore = new RootStore();
